/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseImagePageBlock } from './DatabaseImagePageBlock';
import {
    DatabaseImagePageBlockFromJSON,
    DatabaseImagePageBlockFromJSONTyped,
    DatabaseImagePageBlockToJSON,
} from './DatabaseImagePageBlock';
import type { DatabaseImagePageBlockType } from './DatabaseImagePageBlockType';
import {
    DatabaseImagePageBlockTypeFromJSON,
    DatabaseImagePageBlockTypeFromJSONTyped,
    DatabaseImagePageBlockTypeToJSON,
} from './DatabaseImagePageBlockType';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseImageListPageBlock
 */
export interface DatabaseImageListPageBlock extends DatabaseImagePageBlock {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseImageListPageBlock
     */
    contentList?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DatabaseImageListPageBlock
     */
    interval?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseImageListPageBlock
     */
    showArrowsAlways?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseImageListPageBlock
     */
    loop?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseImageListPageBlock
     */
    autoplay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseImageListPageBlock
     */
    allowRestart?: boolean;
}

/**
 * Check if a given object implements the DatabaseImageListPageBlock interface.
 */
export function instanceOfDatabaseImageListPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseImageListPageBlockFromJSON(json: any): DatabaseImageListPageBlock {
    return DatabaseImageListPageBlockFromJSONTyped(json, false);
}

export function DatabaseImageListPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImageListPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseImagePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'contentList': !exists(json, 'contentList') ? undefined : json['contentList'],
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'showArrowsAlways': !exists(json, 'showArrowsAlways') ? undefined : json['showArrowsAlways'],
        'loop': !exists(json, 'loop') ? undefined : json['loop'],
        'autoplay': !exists(json, 'autoplay') ? undefined : json['autoplay'],
        'allowRestart': !exists(json, 'allowRestart') ? undefined : json['allowRestart'],
    };
}

export function DatabaseImageListPageBlockToJSON(value?: DatabaseImageListPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseImagePageBlockToJSON(value),
        'contentList': value.contentList,
        'interval': value.interval,
        'showArrowsAlways': value.showArrowsAlways,
        'loop': value.loop,
        'autoplay': value.autoplay,
        'allowRestart': value.allowRestart,
    };
}

